import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { ArticleData } from '../Feed';
import { ArticleOrBriefing } from '../Feed/ArticleOrBriefingFeedItem';
import Layout from './Layout';

const queryClient = new QueryClient();

export interface ArticleContent {
  articles: ArticleOrBriefing[];
  contentData: ArticleData;
  commentCounts: { [key: number]: number };
  totalPages: number;
}
interface TopEntity {
  id: number;
  name: string;
  following: boolean;
}

interface TopRelatedEntity {
  matchingEntity: boolean;
  name: string;
}

export type SearchScope = 'articles' | 'directory' | 'forum';

export interface SearchPageProps {
  articleContent: ArticleContent;
  isSignedIn: boolean;
  page: number;
  query?: string;
  scope: SearchScope;
  title: string;
  topEntities?: Array<TopEntity>;
  topRelatedEntities: Array<TopRelatedEntity>;
}

const SearchPage = (props: SearchPageProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Layout {...props} />
    </QueryClientProvider>
  );
};

export default SearchPage;
